module.exports = __webpack_public_path__ + "static/media/SerifBadOptimized.b56bfc90.jp2";